var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Inventory Status","chart":"column","chartType":"inventory_status","isCity":false,"withDate":false,"withFinancial":false,"inventoryStatus":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }